var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sc-render',{attrs:{"fields":_vm.fields,"emptyMessage":_vm.$t('NO_DATA_SOURCE_EXIST')}},[_c('sh-header')],1)}
var staticRenderFns = []

export { render, staticRenderFns }